import React, { ReactNode, useEffect, useState } from 'react'
import styles from '../styles/deleteConfirm.module.scss'
import Dialog from '@/wmCompoments/dialog'
import { useTranslation } from 'react-i18next'

interface Props {
  visible: boolean
  onClose?: () => void
  className?: string
  onSubmit?: (v?: string) => Promise<any>,
}

const DeleteConfirm = (props: Props) => {
  const { visible, onClose } = props

  const { t } = useTranslation('accountManagement')

  return (
    <>
      <Dialog
        visible={visible}
        onClose={() => {
          props?.onClose?.()
        }}
        actions={[

          {
            key: 'cancel',
            text: t('cancel'),
            onClick: () => {
              onClose?.()
            }
          },
          {
            key: 'confirm',
            text: t('confirm'),
            onClick: async () => {
              await props.onSubmit?.()
              onClose?.()
            }
          }
        ]}
        content={
          <div className={styles.dialog_content}>
            <span>{t('importantReminder')}</span>
            <span>{t('confirmDeletionPrompt')}</span>
          </div>
        }
      />
    </>
  )
}

export default DeleteConfirm
